var map = {
	"./AbstractWidget": 107,
	"./AbstractWidget.js": 107,
	"./CarrouselWidget": 1440,
	"./CarrouselWidget.css": 2106,
	"./CarrouselWidget.js": 1440,
	"./HotelBook": 1444,
	"./HotelBook.css": 1445,
	"./HotelBook.js": 1444,
	"./ImageWidget": 1450,
	"./ImageWidget.css": 1451,
	"./ImageWidget.js": 1450,
	"./NewsItemWidget": 1263,
	"./NewsItemWidget.css": 1452,
	"./NewsItemWidget.js": 1263,
	"./NewsWidget": 1453,
	"./NewsWidget.css": 3069,
	"./NewsWidget.js": 1453,
	"./PopUpImageWidget": 1454,
	"./PopUpImageWidget.css": 1455,
	"./PopUpImageWidget.js": 1454
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1251;


//////////////////
// WEBPACK FOOTER
// ./src/cms/widgets ^\.\/.*$
// module id = 1251
// module chunks = 0